module.exports = __webpack_public_path__ + "img/About-Cover-Photo.139860f8.webp";